module.exports = __webpack_public_path__ + "static/media/card-visa.226db966.svg";